import React from 'react';
import './FullHeightLayout.css';
/**
 * 上中下布局组件 - 撑满页面，上下自适应，中间内容超出滚动
 * @param {Object} props 组件属性
 * @param {React.ReactNode} props.headerContent 顶部区域内容
 * @param {React.ReactNode} props.contentContent 中间区域内容
 * @param {React.ReactNode} props.footerContent 底部区域内容
 * @param {string} [props.className=''] 自定义类名
 * @param {React.CSSProperties} [props.headerStyle={}] 顶部自定义样式
 * @param {React.CSSProperties} [props.contentStyle={}] 中间自定义样式
 * @param {React.CSSProperties} [props.footerStyle={}] 底部自定义样式
 * @returns {JSX.Element} 布局组件
 */
const FullHeightLayout = ({
  headerContent = null,
  bodyContent = null,
  footerContent = null,
  className = '',
  style = {},
  headerStyle = {},
  contentStyle = {},
  footerStyle = {},
  children
}) => {
  return (
    <div className={`full-height-layout ${className}`} style={style}>
      {headerContent &&
        <div className="layout-header" style={headerStyle}>
          {headerContent}
        </div>
      }

      {/* 中间内容区域（超出滚动） */}
      <div className="layout-content" style={contentStyle}>
        <div className="content-wrapper">{bodyContent || children}</div>
      </div>

      {footerContent &&
      <div className="layout-footer" style={footerStyle}>
        {footerContent}
      </div>
      }
    </div>
  );
};

export default FullHeightLayout;